module.exports = __webpack_public_path__ + "assets/calculator-input.0c9806a5.svg";